import React from 'react';
import MenuMessage from './menu-message';

import { useJakhubTranslation } from '../../../i18n/jakhub-translation';

import SwitchLink from '../../menus/menu/switch-link/switch-link';

import './menu-message.scss';

import COLORS from '../../../styles/legos/colors.module.scss';
const { akCyan } = COLORS;

export default function HolidayMenuMessage() {
    const { t } = useJakhubTranslation();
    const messageConfig = {
        i18nId: 'AK_HOLIDAYS',
        startPublishDate: '2023-07-01',
        endPublishDate: '2023-08-05',
        cookieResetDate: '2023-08-02',
        bugUserEveryNDays: 7,
        barColor: akCyan,
    };

    const menuMessage = t('general:menu-message.AK_HOLIDAYS', {
        AK_LEARN_MORE_LINK: (
            <SwitchLink
                className='white-link'
                akTestId='HolidayMenuMessage|HOLIDAY_SCHEDULE_MORE_INFO'
                to={{
                    module: 'HELP',
                    subModule: 'SUPPORT',
                    params: { pathHash: 'holiday_schedule' },
                }}
            />
        ),
    });

    return (
        <MenuMessage messageConfig={messageConfig}>
            <div>{menuMessage}</div>
        </MenuMessage>
    );
}
